export const GET_DASHBOARD_DATA = 'GET_DASHBOARD_DATA';
export const CLEAR_DASHBOARD_DATA = 'CLEAR_DASHBOARD_DATA';
export const GET_GROUP_BRANDLIST_DATA = 'GET_GROUP_BRANDLIST_DATA';
export const GET_PARENT_CAMPAIGN_DATA = 'GET_PARENT_CAMPAIGN_DATA';